module.exports = __webpack_public_path__ + "static/media/blog-site.7118f37a.png";